import Vue from 'vue'
import { merge } from 'lodash'

const fetchHelpers = {
  fromVuetifyDatatable (options) {
    return {
      sort: {
        by: options.sortBy,
        order: options.sortDesc.map(desc => desc ? 'desc' : 'asc')
      },
      take: options.itemsPerPage,
      skip: (options.page - 1) * options.itemsPerPage,
    }
  }
}

export default (carrier, id, path, { lambda, features, flattenKey } = {
  features: ['search', 'sort', 'paginate'],
  flattenKey: '_key'
}) => {
  path = path + (path.includes('?') ? '&' : '?') + 'session=' + id

  return new Vue({
    data () {
      return {
        id,
        path,
        loading: true,

        lambda,
        features,
        options: {},
        flattenKey,
      }
    },
    computed: {
      length () {
        return carrier.repository.get(this.path, { items: [], total: 0 }).total
      },
      items () {
        return carrier.repository.get(this.path, { items: [], total: 0 }).items
      }
    },
    methods: {
      async fetch (options = {}) {
        // Resolve special options using helpers
        if ('fromVuetifyDatatable' in options) {
          options = merge(fetchHelpers.fromVuetifyDatatable(options.fromVuetifyDatatable), options)
          options.fromVuetifyDatatable = undefined
        }

        // Save options for a later use
        this.options = options

        // Construct payload to be send with the index request
        const payload = {
          flattenKey: this.flattenKey,
          lambda: typeof this.lambda === 'function' ? this.lambda.toString().replace(/\s+/g, ' ') : undefined,
          features: this.features,
          options
        }

        this.loading = true
        try {
          const result = (await carrier.axios.post(this.path, payload)).data
          this.handleResult(result)
        } finally {
          this.loading = false
        }

        return this
      },
      handleResult (result) {
        carrier.repository.set(this.path, this.id, {
          items: result.data,
          total: result.meta.total
        })
      },
      destroy () {
        this.$destroy()
      }
    },
    created () {
      carrier.indexes[this.id] = this
    },
    destroyed () {
      delete carrier.indexes[this.id]
    }
  })
}